/** 定义消息对象，包含来源和数据信息*/
interface IMessage<T> {
	source: string;
	data: T;
}

/**
 * 通过新开窗口发送消息，搭配 postMessageWithOldTab 使用
 * @param url 新开窗口的地址
 * @param key 消息的确认码，用于标识消息的来源
 * @param data 消息的数据，泛型参数类型
 */
export const postMessageWithOtherTab = <T>(
	url: string,
	key: string,
	data: T
) => {
	// 新开一个窗口
	const newTab = window.open(url);
	if (newTab) {
		// 监听窗口消息，并回复确认消息
		const onMessage = (e: MessageEvent<IMessage<T>>) => {
			if (e.data && e.data.source === key) {
				newTab.postMessage({source: key, data}, location.origin);
				window.removeEventListener('message', onMessage);
			}
		};
		window.addEventListener('message', onMessage);
	}
};

/**
 * 接收新开窗口的消息，搭配 postMessageWithOtherTab 使用
 * @param key 消息的确认码，用于标识消息的来源
 * @param onReceiveMessage 接收到消息后的回调函数，参数为消息的数据，泛型参数类型
 */
export const postMessageWithOldTab = <T>(
	key: string,
	onReceiveMessage: (data: T) => void
) => {
	// 监听窗口消息，并回复确认消息
	const onMessage = (e: MessageEvent<IMessage<T>>) => {
		const data = e.data?.data;
		if (data && e.data.source === key) {
			onReceiveMessage(data);
			window.removeEventListener('message', onMessage);
		}
	};
	if (window.opener) {
		window.addEventListener('message', onMessage);
		window.opener.postMessage({source: key}, location.origin);
	}
};